// extracted by mini-css-extract-plugin
module.exports = {"ElectrificationItem":"ElectrificationListItem_ElectrificationItem__1LgoA","ElectrificationItemEnumName":"ElectrificationListItem_ElectrificationItemEnumName__3UqD-"};